<template>
	<div class="basis-page-cls">
		<table-search-index @filterSelectRemote="filterSelectRemote" :defaultQuery="listQuery" :filterHeader="filterHeader" @filterSearch="filterSearch" pageNumber="pageNum"></table-search-index>
		<div class="im-monitor__table">
			<table-pagination
				v-loading="loading"
				ref="tableItem"
				pagination
				layout="prev,pager,next,total"
				:data="data"
				:column="column"
				:total="total"
				:page.sync="listQuery.pageNum"
				:limit.sync="listQuery.pageSize"
				@pagination="getList">

		</table-pagination>
		</div>
		<!-- 详情 -->
		<Detail v-model="detailsView.show" :source="detailsView.source"></Detail>
	</div>
</template>
<script>
import Detail from './details'
import { mapGetters } from "vuex";
import { filterHeaderSearch } from '@/utils/mixins';
export default {
	mixins:[filterHeaderSearch],
	components:{
		Detail
	},
	computed:{
		 ...mapGetters([
			'subBrandList',
		])
	},
	data(){
		return {
			loading:false,
			data:[],
			column:[
				{
					label: '序号',
					width: 80,
					render: (h, scope) => {
					    return <span>{((this.listQuery.pageNum - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
					}
				},
				{ label: '坐席账号', prop: 'accountName' },
				{ label: '昵称', prop: 'nickName' },
				{ 
					label: '是否可聊天',
					prop: 'enabledChat',
					render:(h,scope) => {
						return <span>{scope.row.enabledChat ? '是' : '否'}</span>
					}
				},
				{
					label: '接线中',
					prop: 'chatNum',
					width:100,
					render: (h, scope) => {
						return <el-button type="text" disabled={scope.row.chatNum == 0} onClick={() => this.onDetail(scope.row)}>{scope.row.chatNum}</el-button>
					}
				},
				{
					label: "登录状态",
					prop: "online",
					render: (h, scope) => {
						return  <el-link underline={false} type={scope.row.online ? 'success' : 'info'}>{scope.row.online ? '在线' : '登出'}</el-link>
					}
				},
				{
					label: "状态",
					prop: "chatStatus",
					render: (h, scope) => {
						return <el-link underline={false} type={scope.row.chatStatus == '空闲' ? 'success' : 'info'}><i class='iconfont major-dian'></i>{scope.row.chatStatus}</el-link>
					}
				},
				{ 
				label: '聊天状态切换时间',
				minWidth: 180,
					prop: 'chatStatusChangeTime',
					render:(h,scope) => {
						return <span>{this.$dayjs(scope.row.chatStatusChangeTime).format('YYYY-MM-DD HH:mm')}</span>
					}
				}
			],
			total:0,
			listQuery:{
				brand:this.$store.state.user.brandId,
				childBrand:'',
				agentName:'',
				pageNum:1,
				pageSize:10,
				userId:''
			},
			filterHeader:[
				{label: '子品牌', model: 'childBrand', type: 'select', default: '', list: []},
				{label: '坐席账号', model: 'userId', type: 'select',  default: '', list: [], loading:false,isRemote:true,labelName:'account',valueName:'account'},
				
			],
			detailsView:{
				show:false,
				source:null
			},
			timer:null
		}
	},
	methods:{
		filterSearch(query){
			this.listQuery = Object.assign(this.listQuery, query);
			this.getList()
		},
		
		onDetail(row){
			this.detailsView = {
				show:true,
				source:row
			}
		},
		getList(){
			this.loading = true;
			this.listQuery.agentName = this.listQuery.userId;
			this.$api.getImImMonitorLists(this.listQuery).then(res => {
				this.loading = false
				if(res.errcode != 0) return;
				this.data = res.list;
				this.total = res.total;
			})
		},
	},
	// destroyed(){
	// 	if(this.timer){
	// 		clearInterval(this.timer);
	// 	}
	// },
	async created(){
		await this.getList();
		this.filterHeader[0]['list'] = await this.subBrandList;
		// this.timer = setInterval(() => {
		// 	this.getList();
		// },5 * 1000)
	}
}
</script>
